// TODO: This component can be removed since the key visuals of the page share only the wrapper. This only creates conlicts with the section component -> no row
import React from 'react';
import styles from './style.module.scss';
import Section from '@jobmatchme/ui/es/components/Section';
import { withThemeVariant } from '@jobmatchme/ui/es/provider/ThemeProvider';

/**
 * The Header component showing a generic header with a optinal background
 * image or color
 *
 * @param	{string}			backgroundClass	A CSS Module containing the background styling
 * @param	{string}			backgroundColor	A css conform hex/rgb/rgba color code
 * @param {Reacr.Node}	The headers children
 **/
import { jsx as _jsx } from "react/jsx-runtime";
export var KeyVisual = function KeyVisual(_ref) {
  var children = _ref.children,
    backgroundClass = _ref.backgroundClass,
    backgroundColor = _ref.backgroundColor,
    _ref$globalThemeVaria = _ref.globalThemeVariant,
    globalThemeVariant = _ref$globalThemeVaria === void 0 ? 'pc' : _ref$globalThemeVaria;
  return /*#__PURE__*/_jsx("div", {
    style: {
      position: 'relative'
    },
    children: /*#__PURE__*/_jsx(Section, {
      noMargin: true,
      noPadding: true,
      backgroundColor: backgroundColor,
      backgroundClass: backgroundClass,
      row: false,
      children: /*#__PURE__*/_jsx("div", {
        className: "".concat(styles.wrapper, " ").concat(styles[globalThemeVariant]),
        children: children
      })
    })
  });
};
export default /*#__PURE__*/React.memo(withThemeVariant(KeyVisual));